import { assign, createMachine } from 'xstate'
import apiMethods from '../api/apiMethods'

let nextIndex = 0

function getID() {
	return nextIndex++
}

export const pointsFormMachine = createMachine(
	{
		id: 'pointsForm',
		context: {
			previews: [],
			files: [],
			errorMessage: [],
			lastName: '',
			firstName: '',
			middleName: '',
			gender: '',
			birthDate: '',
			passportSeries: '',
			passportNumber: '',
			issuedBy: '',
			issueDate: '',
			departmentCode: '',
			inn: '',
			snils: '',
			snilsPhoto: null,
			passportPhoto: null,
			certificate: '',
			prize: '',
			error: null,
		},
		initial: 'init',
		states: {
			init: {
				on: {
					INPUT_FILES: { actions: ['saveFiles'], internal: true },
					DELETE_FILE: { internal: true, actions: ['deleteFile'] },
					INPUT_LAST_NAME: { actions: ['saveLastName'], internal: true },
					INPUT_FIRST_NAME: { actions: ['saveFirstName'], internal: true },
					INPUT_MIDDLE_NAME: { actions: ['saveMiddleName'], internal: true },
					INPUT_GENDER: { actions: ['saveGender'], internal: true },
					INPUT_BIRTH_DATE: { actions: ['saveBirthDate'], internal: true },
					INPUT_PASSPORT_SERIES: {
						actions: ['savePassportSeries'],
						internal: true,
					},
					INPUT_PASSPORT_NUMBER: {
						actions: ['savePassportNumber'],
						internal: true,
					},

					INPUT_ISSUED_BY: { actions: ['saveIssuedBy'], internal: true },
					INPUT_ISSUE_DATE: { actions: ['saveIssueDate'], internal: true },
					INPUT_DEPARTMENT_CODE: {
						actions: ['saveDepartmentCode'],
						internal: true,
					},
					INPUT_INN: { actions: ['saveInn'], internal: true },
					INPUT_SNILS: { actions: ['saveSnils'], internal: true },
					INPUT_SNILS_PHOTO: { actions: ['saveSnilsPhoto'], internal: true },
					INPUT_PASSPORT_PHOTO: {
						actions: ['savePassportPhoto'],
						internal: true,
					},
					DELETE_SNILS_PHOTO: { actions: ['deleteSnilsPhoto'], internal: true },
					DELETE_PASSPORT_PHOTO: {
						actions: ['deletePassportPhoto'],
						internal: true,
					},
					INPUT_CERTIFICATE: {
						actions: ['saveCertificate'],
						internal: true,
					},
					INPUT_PRIZE: {
						actions: ['savePrize'],
						internal: true,
					},
					SUBMIT: {
						target: 'send',
						actions: ['clearError'],
					},
				},
			},
			send: {
				invoke: {
					id: 'upload',
					src: 'upload',
					onDone: {
						target: 'success',
						actions: ['reset'],
					},
					onError: {
						target: 'init',
						actions: ['saveError'],
					},
				},
			},
			success: {
				on: {
					ONE_MORE: {
						target: 'init',
					},
				},
			},
		},
	},
	{
		actions: {
			saveFiles: assign({
				files: (ctx, message) => {
					const newFiles = Array.from(message.data, item => ({
						id: getID(),
						file: item,
						preview: URL.createObjectURL(item),
					}))
					return ctx.files.concat(newFiles)
				},
			}),
			saveLastName: assign({
				lastName: (ctx, message) => message.data,
			}),
			saveFirstName: assign({
				firstName: (ctx, message) => message.data,
			}),
			saveMiddleName: assign({
				middleName: (ctx, message) => message.data,
			}),
			saveGender: assign({
				gender: (ctx, message) => message.data,
			}),
			saveBirthDate: assign({
				birthDate: (ctx, message) => message.data,
			}),
			savePassportSeries: assign({
				passportSeries: (ctx, message) => message.data,
			}),
			savePassportNumber: assign({
				passportNumber: (ctx, message) => message.data,
			}),
			saveIssuedBy: assign({
				issuedBy: (ctx, message) => message.data,
			}),
			saveIssueDate: assign({
				issueDate: (ctx, message) => message.data,
			}),
			saveDepartmentCode: assign({
				departmentCode: (ctx, message) => message.data,
			}),
			saveInn: assign({
				inn: (ctx, message) => message.data,
			}),
			saveSnils: assign({
				snils: (ctx, message) => message.data,
			}),
			saveSnilsPhoto: assign({
				snilsPhoto: (ctx, message) => message.data,
			}),
			savePassportPhoto: assign({
				passportPhoto: (ctx, message) => message.data,
			}),
			saveCertificate: assign({
				certificate: (ctx, message) => message.data,
			}),
			savePrize: assign({
				prize: (ctx, message) => message.data,
			}),
			deleteSnilsPhoto: assign({
				snilsPhoto: null,
			}),
			deletePassportPhoto: assign({
				passportPhoto: null,
			}),
			saveError: assign({
				error: (ctx, message) => ctx.errorMessage.concat(message.data),
			}),
			clearError: assign({
				errorMessage: [],
			}),
			deleteFile: assign({
				files: (ctx, message) => {
					const newList = ctx.files.filter(item => item.id !== message.data)
					return newList
				},
			}),

			// saveError: assign({
			// 	error: (_, event) => event.data,
			// }),
			reset: assign({
				previews: [],
				files: [],
				errorMessage: [],
				lastName: '',
				firstName: '',
				middleName: '',
				gender: '',
				birthDate: '',
				passportSeries: '',
				passportNumber: '',
				issuedBy: '',
				issueDate: '',
				departmentCode: '',
				inn: '',
				snils: '',
				snilsPhoto: null,
				passportPhoto: null,
				certificate: '',
				prize: '',
				error: null,
			}),
			scrollTop: () => window.scrollTo(0, 0),
		},
		services: {
			upload: (ctx, message) =>
				async function (send) {
					const emailRegExp =
						/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

					const errors = {
						lastNameError: '',
						firstNameError: '',
						middleNameError: '',
						genderError: '',
						birthDateError: '',
						passportSeriesError: '',
						passportNumberError: '',
						issuedByError: '',
						issueDateError: '',
						departmentCodeError: '',
						innError: '',
						snilsError: '',
						snilsPhotoError: '',
						passportPhotoError: '',
						certificateError: '',
					}

					const haveErrors = Object.values(errors).some(el => el !== '')

					if (haveErrors) {
						send({
							type: 'ERROR',
							data: errors,
						})
					} else {
						const FD = new FormData()

						for (let i = 0; i < ctx.files.length; i++) {
							FD.append('attachments[]', ctx.files[i].file)
						}

						FD.append('last_name', ctx.lastName)
						FD.append('name', ctx.firstName)
						FD.append('middle_name', ctx.middleName)
						FD.append(
							'sex',
							ctx.gender === 'male' ? 1 : ctx.gender === 'female' ? 0 : null
						)
						FD.append(
							'birth_date',
							new Date(ctx.birthDate).toLocaleDateString('ru-RU')
						)
						FD.append('passport_series', ctx.passportSeries.replace(/\s+/g, ''))
						FD.append('passport_number', ctx.passportNumber)
						FD.append('passport_issued_by', ctx.issuedBy)
						FD.append(
							'passport_issued_at',
							new Date(ctx.issueDate).toLocaleDateString('ru-RU')
						)
						FD.append('passport_department_code', ctx.departmentCode)
						FD.append('inn', ctx.inn)
						FD.append('snils', ctx.snils)
						if (ctx.snilsPhoto) {
							FD.append('snils_file', ctx.snilsPhoto.file || ctx.snilsPhoto)
						}

						if (ctx.passportPhoto) {
							FD.append(
								'passport_file',
								ctx.passportPhoto.file || ctx.passportPhoto
							)
						}

						const response = await apiMethods.pointsForm.sendPoints(FD)

						if (response.status === 200) {
							send({
								type: 'DONE',
							})
							const response2 = await apiMethods.bonuses.setOrder(
								Number(ctx.prize)
							)
						} else {
							send({
								type: 'ERROR',
								data: {
									serverError: response.message,
								},
							})
						}
					}
				},
		},
	}
)
